import getNavigationState from "./navigation-state.js";
import { decorateExternalLink } from "./navigation-utils.js";
export default function initCategorySections() {
  console.log("CATEGORY FILE LOADED 🚨🚨🚨");
  console.log("INIT Category Sections RUNNING");

  const container = document.querySelector("[data-module='category-sections']");
  if (!container) return;

  const state = getNavigationState();
  if (!state?.current) return;

  console.log("STATE:", state);
  console.log("CURRENT:", state.current);
  console.log("CHILDREN:", state.current.children);

  const items = state.current.children || [];
  if (!items.length) return;

  // ✅ Layout switch (correct)
  document.body.setAttribute("data-layout", "category-sections");

  const grid = document.createElement("div");
  grid.className = "sz-category-grid sz-category-grid--automated";

  items.forEach((item) => {
    const a = document.createElement("a");
    a.href = String(item.url || "").trim();
    a.className = "sz-card sz-card--category sz-card--category-automated";

    const title = document.createElement("span");
    title.className = "sz-card__title";
    title.textContent = item.label;

    a.appendChild(title);

    decorateExternalLink(a, item.url);

    grid.appendChild(a);
  });

  container.replaceChildren(grid);
}
